import { useQuery } from "@tanstack/react-query";

import { apiAvatar } from "@/services/api-client/avatar";

import { avatarKeys } from "./avatars.keys";

export const useGetAvatarsQuery = () =>
  useQuery({
    queryKey: avatarKeys.all,
    queryFn: () => apiAvatar.getAvatars(),
  });
